module.exports = __webpack_public_path__ + "img/advanced_fighters_hall_small.18604498.png";